/**
 * AnnouncementMediaService
 * Service for managing announcement media attachments
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement media CRUD operations
 */
export class AnnouncementMediaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementMediaService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all media for a specific announcement
     * GET /api/announcement-media/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement media
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all media for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
}
AnnouncementMediaService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementMediaService.BASE_PATH = 'api/announcement-media';
//# sourceMappingURL=AnnouncementMediaService.js.map